<div class="header-container">
  <!-- Section Gauche -->
  <div class="header-left">
    <i class="fas fa-user user-icon"></i>
    <span class="user-name">{{ name }}</span>
    <span class="header-date">
      Date: <span  *ngIf="colors" style="color:#000">{{Date}}</span>
      <span *ngIf="!colors"  style="color:red">{{Date}}</span>
    </span>
  </div>

  <!-- Section Centre -->
  <div class="header-center" *ngIf="MyPOS">
    <i class="fas fa-briefcase service-icon"></i>
    <span>Service: {{ MyPOS.name }}</span>
  </div>

  <!-- Section Droite -->
  <div class="header-right">
    <div class="speed-info">
      <div class="speed-circle" [ngClass]="circleClass"></div>
      <span>{{ speedMessage }}</span>
    </div>
    <div *ngIf="nameHotel" class="hotel-info">
      <i class="fas fa-hotel hotel-icon"></i>
      <span>{{ nameHotel }}</span>
    </div>

    <!-- Menu Déroulant -->
    <div class="dropdown-wrapper" ngbDropdown placement="bottom-right">
      <button ngbDropdownToggle class="dropdown-btn">
        <mat-icon>account_circle</mat-icon>
      </button>


   <div ngbDropdownMenu>
        <button class="dropdown-item">Profile</button>
      <button class="dropdown-btn" style="margin-left: 10%;" (click)="toggleDropdown('hotel', $event)">
        Connected Hotel
        <span class="arrow-icon" [class.rotate-arrow]="showPreferredHotels" (click)="toggleDropdown('hotel', $event)">&#9660;</span>
      </button>
      <ng-container *ngIf="showPreferredHotels">
        <div class="dropdown-content" (mousedown)="onDropdownContentClick($event)" style="margin-left: 10%;">
          <button class="dropdown-item" *ngFor="let hot of ListPriveredgroup; let i = index" (click)="NewGroup(i); $event.stopPropagation()">{{hot.name}}</button>
        </div>
      </ng-container>

      <button class="dropdown-btn" style="margin-left: 10%;" (click)="toggleDropdown('service', $event)">
        Connected Service 
        <span class="arrow-icon" [class.rotate-arrow]="showPreferredServices" (click)="toggleDropdown('service', $event)">&#9660;</span>
      </button>
      <ng-container *ngIf="showPreferredServices">
        <div class="dropdown-content" (mousedown)="onDropdownContentClick($event)" style="margin-left: 10%;">
          <button class="dropdown-item" *ngFor="let serv of ListPriveredService; let i = index" (click)="NewService(i); $event.stopPropagation()">{{serv.name}}</button>
        </div>
      </ng-container>


        <!-- <button class="dropdown-item">Settings</button> -->
        <div class="dropdown-divider"></div>
        <button class="dropdown-item" (click)="logout()">Disconnect</button>
      </div>


    </div>
  </div>
</div>
